import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ResourceLibrary from "./ResourceLibrary";
import ResourceUpload from "./FileUploadOrDrag";
import localization from "services/localization";
import SpecificAPI from "services/SpecificApi";
import { useUserStore } from "context/useUserStore";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";

export default function ResourceManagerModal({
  show,
  onClose,
  onSelectResources,
  resources = [],
  setResources,
  loading,
  setLoading,
  resourceType,
  selectedResources,
}) {
  // const [selectedResources, setSelectedResources] = useState(
  //   modalResources || [],
  // );
  const [isUploading, setIsUploading] = useState(false);
  const { appUser, userData } = useUserStore();
  const [selectedIds, setSelectedIds] = useState(selectedResources || []);
  const [uploadError, setUploadError] = useState("");

  const handleUploadClick = () => setIsUploading(true);

  // useEffect(() => {
  //   setSelectedResources(modalResources || []);
  // }, [modalResources]);
  const getData = async (userId) => {
    try {
      setLoading(true);

      // const [userResources, publicResources] = await Promise.all([
      //   SpecificAPI.getAllResources(
      //     {
      //       user_id: userId,
      //     },
      //     userData?.selected_school_id,
      //   ),
      //   SpecificAPI.getAllResources(
      //     {
      //       visibility_scope: "public",
      //     },
      //     userData?.selected_school_id,
      //   ),
      // ]);

      const resources = await SpecificAPI.getAllResources(
        { enabled: true },
        userData?.selected_school_id,
      );

      // const merged = [...userResources, ...publicResources];
      // const uniqueResources = Array.from(
      //   new Map(merged.map((r) => [r.id, r])).values(),
      // );

      setResources(resources);
    } catch (error) {
      console.error("Failed to fetch resources", error);
    } finally {
      setLoading(false);
    }
  };
  const handleResourceUpload = async (formData) => {
    try {
      setLoading(true);
      const res = await SpecificAPI.createResources(formData);
      if (res?.status === 200 || res?.status === 201) {
        toast.success("Resources uploaded successfully!");
        await getData(appUser.id);
      }
      return res;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // const handleSelectResource = (resource) => {
  //   setSelectedResources((prev) => {
  //     const exists = prev.some((r) => r.id === resource.id);
  //     return exists
  //       ? prev.filter((r) => r.id !== resource.id)
  //       : [...prev, resource];
  //   });
  // };

  const handleRemoveSelected = (id) => {
    var updated = selectedIds.filter((i) => i !== id);
    setSelectedIds(updated);
  };

  const handleSelectResource = (ids) => {
    setSelectedIds(ids);
  };

  const handleUseResources = () => {
    // const ids = selectedResources.map((r) => r.id || r);
    onSelectResources(selectedIds);
    onClose();
  };

  const handleBackClick = () => {
    setIsUploading(false);
    setUploadError("");
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      dialogClassName="modal-90w"
      fullscreen="md-down"
      className="themed-modal addEditModal"
    >
      <Modal.Body
        style={{ maxHeight: "85vh", overflowY: "auto", position: "relative" }}
      >
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-50">
            <ClipLoader size={50} color="var(--primary-icon)" />
          </div>
        )}
        {!isUploading ? (
          <ResourceLibrary
            resources={resources}
            selectedResources={selectedResources}
            onUploadClick={handleUploadClick}
            onSelectResources={handleSelectResource}
            setResources={setResources}
            loading={loading}
            setLoading={setLoading}
            resourceType={resourceType}
            selectedIds={selectedIds}
            onRemoveSelected={handleRemoveSelected}
          />
        ) : (
          <ResourceUpload
            onResourceUpload={handleResourceUpload}
            onBackClick={handleBackClick}
            appUser={appUser}
            userData={userData}
            loading={loading}
            resourceType={resourceType}
            uploadError={uploadError}
            setUploadError={setUploadError}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={selectedIds.length === 0}
          onClick={handleUseResources}
          className="action-btn primary disabled:opacity-50 py-2 rounded-lg font-semibold"
        >
          {localization.use_selected_resources || "Use Selected Resources"}
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          {localization.close || "Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
